// import React, { useState } from "react";

// import {
//   Container,
//   Title,
//   Header,
//   HeaderTitle,
//   HeaderIconLeft,
//   HeaderIconRight,
//   TableContainer,
//   TableHeader,
//   TableBody,
//   Pagination,
// } from "./Component/TableComponent/Table";
// import InputSearch from "./Component/Search/Search";
// import PickColumn from "./Component/PickColumn/PickColumn";
// import Action from "./Component/Action/Action";
// import AddGroup from "./Component/AddGroup/AddGroup";
// import CreatedOn from "./Component/CreatedOn/CreatedOn";
// import Filter from "./Component/Filter/Filter";
// import { osplist } from "./Component/Utils/Utils";
// import BulkExport from "./Component/BulkButton/BulkExport";
// import { LuRefreshCcw } from "react-icons/lu";
// import { Tooltip as ReactTooltip } from "react-tooltip";
// import { FaEdit, FaPlus, FaSave } from "react-icons/fa";

// function RelatedProductSettings() {
//   const [open, setOpen] = useState(false);
//   const [edit, setEdit] = useState(false);
//   return (
//     <div>
//       <ReactTooltip
//         id="main-tooltip"
//         place="top"
//         effect="solid"
//         className="!text-[14px] !rounded-md !px-2 !py-[2px] !text-white z-20 shadow-md"
//       />

//       <div className="flex justify-between">
//         {/* Left section */}
//         <div className="flex w-full justify-start items-center gap-2">
//           <p className="text-xl text-gray-500 font-semibold">
//             Create Unit
//           </p>

//           <div
//             data-tooltip-id="main-tooltip"
//             data-tooltip-content="Refresh"
//             className="bg-gray-200 shadow-sm rounded-md cursor-pointer px-1 py-1 flex items-center justify-center"
//           >
//             <LuRefreshCcw size={18} className="text-gray-500 m-1" />
//           </div>

//           <button
//             onClick={() => setEdit(!edit)}
//             data-tooltip-id="main-tooltip"
//             data-tooltip-content={edit ? "Edit" : "Save"}
//             className={`text-sm text-white shadow-sm font-semibold rounded-md px-3 py-2 flex gap-2 items-center justify-center cursor-pointer transition-all ${
//               !edit ? "bg-gray-600" : "bg-green-600"
//             }`}
//           >
//             {edit ? (
//               <>
//                 <FaSave size={18} />
//                 Save
//               </>
//             ) : (
//               <>
//                 <FaEdit size={18} />
//                 Edit
//               </>
//             )}
//           </button>
//         </div>

//         {/* Right section */}
//         <div className="flex w-full gap-2 justify-end">
//           <button
//             onClick={() => setOpen(true)}
//             disabled={!edit}
//             data-tooltip-id="main-tooltip"
//             data-tooltip-content="Create Enquiries"
//             className={`text-sm shadow-sm font-semibold rounded-md px-5 py-2 flex gap-2 items-center justify-center text-center transition-all ${
//               edit
//                 ? "bg-red-600 text-white hover:bg-red-700"
//                 : "bg-red-300 text-white cursor-not-allowed"
//             }`}
//           >
//             <FaPlus size={18} />
//             Create Enquiries
//           </button>

//           <BulkExport content="Export" />
//           <Pagination />
//         </div>
//       </div>

//       <Trending_Table />
//     </div>
//   );
// }

// export default RelatedProductSettings;

// function Trending_Table() {
//   const RowHeader = ["Product ID", "Status", "Product Name"];

//   return (
//     <div>
//       <Container>
//         {/* <Title showImport={false}> High Demand / Hot Enquiries</Title> */}
//         <Header>
//           <TableContainer>
//             <TableHeader children={RowHeader} />
//             <TableBody rows={osplist} />
//           </TableContainer>
//         </Header>
//       </Container>
//     </div>
//   );
// }
import React from "react";
import Title from "./Component/Title/Title"
import Table from "./Component/TableComponent/Table"


export default function RelatedProductSettings() {
  return (
    <div className="p-4">
    <Title/>
      <Table />
     
    </div>
  );
}